import React from 'react';
import Isvg from 'react-inlinesvg';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import CopyIcon from 'app/images/icons/copy.svg';

interface ICopyCaptionProps {
  text: string;
}

export default class CopyCaption extends React.Component<ICopyCaptionProps> {
  static defaultProps: ICopyCaptionProps = {
    text: undefined,
  };

  toggleTooltip = () => {
    this.setState(() => (prevState) => ({ tooltipOpen: !prevState.tooltipOpen }));
  };

  render(): React.ReactNode {
    return (
      <div>
        <CopyToClipboard text={this.props.text}>
          <div className="copy-caption-container">
            <span className="copy-caption-text body-text">
              {this.props.text}
            </span>
            <Isvg className="d-inline block copy-caption-icon" src={CopyIcon} />
          </div>
        </CopyToClipboard>
      </div>
    );
  }
}
